import './Footer.css';

export default function Footer(props) {
 
  return (
    <>
      <div className='footer1'>
       
        <h6>© Tourcoing 2025-{new Date().getFullYear()}</h6>

        
      </div>
    </>
  );
}
